
export class ApplicantData {

    constructor(UserIDSerial, SEMESTERID, Username, Password,
        UserEmail, LastName, FirstName, NationalityNameEN,
        GenderName, SEMESTERNAME, BirthDate, NationID, NationalityId,
        ReligionID, SecondNameEN, ThirdNameEN, FamilyNameAR,
        LastNameAR, SecondNameAR, ThirdNameAR, FirstNameAR,
        FamilyNameEN, ReligionNameEN, UserTypeID, ApplicantID,
        Token
    ) {

       this.UserIDSerial = UserIDSerial,
       this.SEMESTERID = SEMESTERID,
       this.Username = Username,
       this.Password = Password,
       this.UserEmail = UserEmail,
       this.LastName = LastName,
       this.FirstName = FirstName,
       this.NationalityNameEN = NationalityNameEN,
       this.GenderName = GenderName,
       this.SEMESTERNAME = SEMESTERNAME,
       this.BirthDate = BirthDate,
       this.NationID = NationID,
       this.NationalityId = NationalityId,
       this.ReligionID = ReligionID,
       this.SecondNameEN = SecondNameEN,
       this.ThirdNameEN =ThirdNameEN,
       this.FamilyNameAR = FamilyNameAR,
       this.LastNameAR = LastNameAR,
       this.SecondNameAR = SecondNameAR,
       this.ThirdNameAR = ThirdNameAR,
       this.FirstNameAR = FirstNameAR,
       this.FamilyNameEN = FamilyNameEN,
       this.ReligionNameEN = ReligionNameEN,
       this.UserTypeID =UserTypeID,
       this.ApplicantID = ApplicantID,
       this.Token = Token

    }
}

export class ApplicantContact{
     constructor(ApplicantID,ContactTypeID,ContactDetails,IsPrimary,phoneCode){

        this.ApplicantID  = ApplicantID,
        this.ContactTypeID  = ContactTypeID,
        this.ContactDetails =  ContactDetails,
        this.IsPrimary  = IsPrimary,
        this.phoneCode = phoneCode
     }
}

export class Countries{
    
    constructor( Serial,ContinentID,CountryNameAR,CountryNameEN,NationalityNameAR,NationalityNameEN,CurrentCountry){
    
       this.Serial = Serial ,
       this.ContinentID = ContinentID ,
       this.CountryNameAR = CountryNameAR ,
       this.CountryNameEN = CountryNameEN ,
       this.NationalityNameAR = NationalityNameAR , 
       this.NationalityNameEN = NationalityNameEN ,
       this.CurrentCountry = CurrentCountry
    }
    
}
export class Governrates{
    constructor(CountryID,Serial,GovernorateName,GovernorateNameEN,IsPrimary){
        
        
       this.CountryID   =     CountryID   
       this.Serial = Serial
       this.GovernorateName = GovernorateName
       this.GovernorateNameEN = GovernorateNameEN
       this.IsPrimary = IsPrimary
       

    }
}
export class ApplicantAdress{
    constructor(ApplicantID,CountrySerial,GovernerateSerial,Address){
        this.ApplicantID  = ApplicantID,
        this.CountrySerial =CountrySerial ,
        this.GovernerateSerial =GovernerateSerial,
        this.Address=Address
    }
}

export class Certifications{
    constructor(serial,CertificationNameAR,CertificationNameEN,CertificationGroupID,MinistryGroupID,IsDeleted){
        this.serial = serial,
        this.CertificationNameAR = CertificationNameAR,
        this.CertificationNameEN =CertificationNameEN ,
        this.CertificationGroupID = CertificationGroupID,
        this.MinistryGroupID = MinistryGroupID,
        this.IsDeleted =IsDeleted
    }
}
export class CertificationsSpecialization{
    constructor(SpecializationTypeID,SpecializationNameAR,SpecializationNameEN){
        this.SpecializationTypeID = SpecializationTypeID,
        this.SpecializationNameAR = SpecializationNameAR,
        this.SpecializationNameEN =SpecializationNameEN 
    
    }
}
export class ApplicantCertifications{
    constructor(   ApplicantID,CertificateTypeID, SpecializationTypeID,  Degree, Percentage,YearID){
             this.ApplicantID=ApplicantID,
             this.CertificateTypeID=CertificateTypeID,
             this.SpecializationTypeID=SpecializationTypeID,
             this.Degree=Degree,
             this.Percentage=Percentage,
             this.YearID=YearID
    }
}

export class Years{
    constructor( Serial,Year,IsDeleted){
              this.Serial =Serial,
              this.Year =Year,
              this.IsDeleted= IsDeleted
    }
}

export class Campus{
    constructor(BranchSerial, BrancheNameEN,BrancheNameAR){
        this.BranchSerial =BranchSerial 
        this.BrancheNameEN=BrancheNameEN
        this.BrancheNameAR=BrancheNameAR
    }
}
export class Faculty{
    constructor(FacultyBranchID,FacultyNameEN,FacultyNameAR){
       this.FacultyBranchID =FacultyBranchID
       this.FacultyNameEN = FacultyNameEN
       this.FacultyNameAR = FacultyNameAR
    }
}
export class PreferencesList{
    constructor(PreferenceSerial,PreferenceNameEN,PreferenceNameAR){
       this.PreferenceSerial =PreferenceSerial
       this.PreferenceNameEN = PreferenceNameEN
       this.PreferenceNameAR = PreferenceNameAR
    }
}
export class ApplicantPreferences {
    constructor(ApplicantID , FacultyBranchID, PreferenceID,EnrollmentTypeID,CampusId){
        this.ApplicantID    =  ApplicantID    
        this.FacultyBranchID=FacultyBranchID
        this.PreferenceID   = PreferenceID   
        this.EnrollmentTypeID=EnrollmentTypeID
        this.CampusId = CampusId
    }
}
export class EnrollmentType{
    constructor(Serial,ApplicantStatusEN,ApplicantStatusAR,IsDeleted){
       this.Serial = Serial
       this.ApplicantStatusEN =ApplicantStatusEN
       this.ApplicantStatusAR = ApplicantStatusAR
       this.IsDeleted = IsDeleted
    }
    
}

export class ApplicantPreferencesList{
    constructor(PreferenceNameAR,PreferenceNameEN,BrancheNameEN,BrancheNameAR,FacultyNameEN,FacultyNameAR
        ,ApplicantStatusEN,
        ApplicantStatusAR,
        SemesterName,serial){
            this.serial = serial
        this.PreferenceNameAR=PreferenceNameAR
        this.PreferenceNameEN=PreferenceNameEN
        this.BrancheNameEN=BrancheNameEN
        this.BrancheNameAR=BrancheNameAR
        this.FacultyNameEN=FacultyNameEN
        this.FacultyNameAR=FacultyNameAR
        this.ApplicantStatusEN=ApplicantStatusEN
        this.ApplicantStatusAR=ApplicantStatusAR
        this.SemesterName=SemesterName
    }
}

export class AttachmentTypes{
    constructor(FileAttachmentsTypeID,FileAttachmentTypeNameEN,FileAttachmentTypeNameAR){
        this.FileAttachmentsTypeID=FileAttachmentsTypeID
        this.FileAttachmentTypeNameEN=FileAttachmentTypeNameEN
        this.FileAttachmentTypeNameAR=FileAttachmentTypeNameAR
    }
}
export class ApplicantPaymentList{
    constructor(FullNameAR, FullNameEN, PaymentStatues, FacultyNameAR, FacultyNameEN,BrancheNameAR,BrancheNameEN
        ,PaymentTypeNameAR, PaymentTypeNameEN, Value,PaymentDateFrom,PaymentDateTo,PaymentDate, ReceiptNumber,EmployeeNameAR
        ,EmployeeNameEN, SemesterName,serial){
       this.FullNameAR=FullNameAR
       this.FullNameEN=FullNameEN
       this.PaymentStatues=PaymentStatues
       this.FacultyNameAR=FacultyNameAR
       this.FacultyNameEN=FacultyNameEN
       this.BrancheNameAR=BrancheNameAR
       this.BrancheNameEN=BrancheNameEN
       this.PaymentTypeNameAR=PaymentTypeNameAR
       this.PaymentTypeNameEN=PaymentTypeNameEN
       this.Value=Value
       this.PaymentDateFrom=PaymentDateFrom
       this.PaymentDateTo=PaymentDateTo
       this.PaymentDate=PaymentDate
       this.ReceiptNumber=ReceiptNumber
       this.EmployeeNameAR=EmployeeNameAR
       this.EmployeeNameEN=EmployeeNameEN
       this.SemesterName=SemesterName
       this.serial=serial
    }
}

export class ApplicantActionsHistoryList{
    constructor(ApplicationID,SemesterName,BrancheNameAR,BrancheNameEN,FacultyNameAR,FacultyNameEN,ApplicantDate,StatusNameEN,        ProcessNameEN,        Percentage,        AppCurrentPro,
        ActionStatus, PreferenceNameEN ,ApplicationHistoryID){
        this.ApplicationID=ApplicationID
        this.SemesterName =SemesterName
        this.BrancheNameAR=BrancheNameAR
        this.BrancheNameEN=BrancheNameEN
        this.FacultyNameAR=FacultyNameAR
        this.FacultyNameEN=FacultyNameEN
        this.ApplicantDate=ApplicantDate
        this.StatusNameEN =StatusNameEN
        this.ProcessNameEN=ProcessNameEN
        this.Percentage   =Percentage
        this.AppCurrentPro=AppCurrentPro
        this.ActionStatus =ActionStatus
        this.PreferenceNameEN=PreferenceNameEN
        this.ApplicationHistoryID  = ApplicationHistoryID
    }

}
export class SetPrimary{
    constructor( RowSerial, FlagContacttype, Primary, ApplicantID){
        this.RowSerial = RowSerial
        this.FlagContacttype=FlagContacttype
        this.Primary=Primary
        this.ApplicantID=ApplicantID
    }
}
 export class BookExamTYpe{
     constructor(ExamTypeID,
        ApplicantExamID,
        ApplicantID){
        this.ExamTypeID = ExamTypeID
        this.ApplicantExamID = ApplicantExamID
        this.ApplicantID = ApplicantID
     }
 }
 export class ExamLocation{
     constructor(ExamID,
        ApplicantExamID,ExamDates,
        Location,ExamDateID,ApplicantID,ExamLocationsID){
        this.ExamID = ExamID
        this.ApplicantExamID = ApplicantExamID
        this.Location = Location
        this.ExamDates = ExamDates
        this.ExamDateID = ExamDateID
        this.ApplicantID = ApplicantID
        this.ExamLocationsID = ExamLocationsID

     }
 }
export class TermsAccept{
    constructor(ApplicantSerial ,termSerial,FlagTerm,isAgreed){
      this.ApplicantSerial=ApplicantSerial
      this.termSerial=termSerial
      this.FlagTerm=FlagTerm
      this.isAgreed=isAgreed
    }
}
export class ApplicantParent{
    constructor(ApplicantID ,ParentFirstNameEN,ParentSecondNameEN,ParentThirdNameEN,
        ParentFamilyNameEN,ParentLastNameEN,
        ParentFirstNameAR,ParentSecondNameAR,ParentThirdNameAR,ParentFamilyNameAR,ParentLastNameAR,ParentNationID,
        ParentJob,ParentEmail,ParentPhone){
        this.ApplicantID =ApplicantID 
        this.FirstNameEN=ParentFirstNameEN  
       this.SecondNameEN =ParentSecondNameEN 
        this. ThirdNameEN =  ParentThirdNameEN
       this.FamilyNameEN  =ParentFamilyNameEN
       this.LastNameEN  =ParentLastNameEN
       this.FirstNameAR  =ParentFirstNameAR
       this.SecondNameAR = ParentSecondNameAR
       this.ThirdNameAR  =  ParentThirdNameAR
       this.FamilyNameAR =  ParentFamilyNameAR
       this.LastNameAR = ParentLastNameAR
       this. ParentNationID= ParentNationID
       this. ParentJob =ParentJob
       this. ParentEmail = ParentEmail
       this. ParentPhone =ParentPhone
    }
}